/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API48182Req {
  
  /** 执行方式：together=共同执行，separate=分别执行 */
  executionType?: string;
  /** 任务标题 */
  taskTitle?: string;
  /** 任务内容描述 */
  taskDesc?: string;
  /** 执行人用户id列表 ,String */
  taskExecutorIdList?: any[];
  /** 抄送人用户id列表 ,String */
  taskCcIdList?: any[];
  /** 任务完成标准(1:或签,2:会签，默认1)，详见TaskCompleteTypeEnum */
  taskCompleteType?: number;
  /** 计划开始时间yyyy-MM-ddHH:mm:ss */
  startTime?: any;
  /** 计划完成时间yyyy-MM-ddHH:mm:ss */
  endTime?: any;
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  /** 能否处理已逾期的任务 */
  canExecOverdue?: boolean;
  /** 父级任务id */
  parentTaskId?: number;
  /** 消息提醒规则，from数据字典，默认no_notify不提醒 */
  notifyRule?: string;
  /** 业务数据编号 */
  bizNo?: string;
  /** 任务权限归属者id */
  ownerId?: string;
  /** 任务归属者类型,1:创建者,2:主播,3:项目 */
  ownerType?: number;
  /** 业务类型,项目为:project_mgr,普通业务:common,直播计划:live_plan */
  bizType?: string;
  /** 业务域.具体值字典表中维护 */
  bizDomain?: number;
};



export interface API48182Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 48182 创建任务

export interface IUsePostAPI48182Return {
  /** 创建任务: 接口请求状态 */
  isAPI48182Loading: boolean;
  /** 创建任务: 接口请求返回数据 */
  dataAPI48182: API48182Res;
  /**  创建任务: 接口数据请求方法 */
  fetchAPI48182Data:  (inputs: API48182Req, config?: YWRequestConfig) => Promise<API48182Res>;
  /** 创建任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48182 = ():IUsePostAPI48182Return => {
  let isMount = true;
  const [isAPI48182Loading, setIsAPI48182Loading] = useState(false);
  const [dataAPI48182, setDataAPI48182] = useState<API48182Res>({} as API48182Res);
  const requestUrl = `${basePath}/team-work/workTask/createWorkTask`;

  const fetchAPI48182Data = async (inputs: API48182Req, config?: YWRequestConfig): Promise<API48182Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48182Req>) || {}) as API48182Req;
    
  
    if ( isMount ) {
      setIsAPI48182Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48182Res>(`${basePath}/team-work/workTask/createWorkTask`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48182(res || {} as API48182Res);
        setIsAPI48182Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48182Loading(false);
      }
      return false as unknown as API48182Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48182Loading,
    dataAPI48182,
    fetchAPI48182Data,
    requestUrl,
  }
}

